import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { Divider } from "primeng/divider";

@Component({
  selector: "new-ui-formly-divider",
  templateUrl: "./new-ui-formly-divider.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Divider],
})
export class NewUiFormlyDividerComponent extends FieldType {}
